<!-- Empty -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- Vertical -->
<vertical-layout *ngIf="layout === 'classy'"></vertical-layout>

<!-- Landing Pages -->
<before-login-layout *ngIf="layout === 'before'"></before-login-layout>

